import axios from '../index';

const getBaseUrl = () => process.env.NODE_ENV === 'development' ? '/api' : '/api';
const apiPath = '/v1/nimi/huanji/healthmobile';

const post = async (endpoint, data = {}) => {
    const baseUrl = getBaseUrl();
    console.log(`${baseUrl}${apiPath}/${endpoint}`)
    const res = await axios.post(`${baseUrl}${apiPath}/${endpoint}`, data);
    return res;
};

const authPost = async (endpoint, code, storageKey) => {
    const res = await post(endpoint, { code });
    if(res.success) {
        localStorage.setItem(storageKey, JSON.stringify(res.data));
    }
    return res.data;
};

export const authorize = async (code) => authPost('mpauthrozie', code, 'mp_user');
export const comAuthorize = async (code) => authPost('comauthrozie', code, 'com_user');
export const updateStatus = async (data) => post('updatestatus', data);
export const uploadFile = async (data, onProgress) => {
    const baseUrl = getBaseUrl();
    const res = await axios.post(`${baseUrl}${apiPath}/uploadfile`, data, {
        onUploadProgress: onProgress,
    });
    return res;
};
export const getMpJssdkConfig = async (data) => post('getmpjssdkconfig', data);
export const getJssdkConfig = async (data) => post('getjssdkconfig', data);
export const getCropJssdkConfig = async (data) => post('getcropjssdkconfig', data);
export const getQuestionnaire = async (data) => post('getanwser', data);
export const submitQuestionnaire = async (data) => post('submitanwser', data);
export const login = async (data) => post('login', data);
export const getUser = async (data) => post('getuser', data);
export const getUserClient = async (data) => post('getuserclient', data);
export const getClientById = async (data) => post('getclientbyid', data);
export const getHistoryQuestionnaire = async (data) => post('gethistory', data);
export const getServerList = async (data) => post('getserverlist', data);
export const getAnswerList = async (data) => post('getanwserlist', data);
export const getAnswerDetail = async (data) => post('getanwserdetail', data);
export const updatePassword = async (data) => post('updatepassword', data);
export const share = async (data) => post('share', data);
export const fetchcount = async (data) => post('fetchcount', data);
export const fetchuser = async (data) => post('fetchuser', data);
export const fetchremain = async (data) => post('fetchremain', data);
export const ordersign = async (data) => post('ordersign', data);
export const orderpay = async (data) => post('orderpay', data);
export const searchShareLog = async (data) => post('searchsharelog', data);
export const qrcode = async (data) => post('qrcode', data);
export const checkservice = async (data) => post('checkservice', data);
export const checkqrcode = async (data) => post('checkqrcode', data);
export const updateDesc = async (data) => post('updatedesc', data);
export const searchTask = async (data) => post('searchtask', data);
export const finishTask = async (data) => post('finishtask', data);
export const updateTaskTime = async (data) => post('updatetasktime', data);

// ===================================
//             客户信息管理
// ===================================
export const searchCustomer = async (data) => post('searchCustomer', data);
export const getCustomerByAgentId = async (data) => post('getByAgentIdCustomer', data);
export const addCustomer = async (data) => post('addCustomer', data);
export const modifyCustomer = async (data) => post('modifyCustomer', data);
export const getCustomerById = async (data) => post('getByIdCustomer', data);
export const getCustomerByPhone = async (data) => post('getByPhoneCustomer', data);
export const deleteCustomer = async (data) => post('deleteCustomer', data);
export const batchDeleteCustomer = async (data) => post('batchDeleteCustomer', data);
export const getCustomerStatistics = async (data) => post('getStatisticsCustomer', data);
export const checkCustomerExist = async (data) => post('existCustomer', data);
export const exportCustomer = async (data) => post('exportCustomer', data);